module.exports = __webpack_public_path__ + "img/VA.f57ca707.svg";